import script from "./Registration.vue?vue&type=script&setup=true&lang=js"
export * from "./Registration.vue?vue&type=script&setup=true&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=32c6d87e&scoped=true&lang=css"
script.__scopeId = "data-v-32c6d87e"

export default script